
import Vue from 'vue'
import App from './App.vue'
import VueTouch from 'vue-touch'

Vue.config.devtools = true

VueTouch.config.pan = {
  direction: 'horizontal'
}

Vue.use(VueTouch)


new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js